module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "praise"
    }
  }, [_vm._v("PRAISE FOR THE WRITING OF SARAH ZETTEL")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("RECLAMATION")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Winner of the Locus Award for Best First Novel")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“An exciting new talent . . . Ms. Zettel’s confident treatment of her ambitious material shows just how entertaining the ‘grand tradition of Heinlein and Asimov’ can be in her sympathetic hands.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“This one has scope and sweep, intrigue and grandiose technologies, and grand adventure. Sarah Zettel is a writer to watch.” —"), _c('i', [_vm._v("Analog Science Fiction & Fact")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“In the grand tradition of Heinlein and Asimov . . . More than an exciting science fiction adventure story—it also gives us a universe, vividly imagined and thought provoking.” —Poul Anderson, author of "), _c('i', [_vm._v("Harvest of Stan")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("FOOL’S WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A "), _c('i', [_vm._v("New York Times")]), _vm._v(" Notable Book of the Year")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Wrenchingly real.” —"), _c('i', [_vm._v("The Philadelphia Inquirer")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“This thought-provoking tale offers an energetic plot and a cast full of appealing characters.” —"), _c('i', [_vm._v("The Plain Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“An exciting, stimulating and imaginative book. Zettel handles her intriguing cast of characters, both human and AI, with style and confidence.” —SF Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("PLAYING GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Energetic and entertaining . . . with many clever twists.” —"), _c('i', [_vm._v("The Plain Dealer")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Absorbing and exciting . . . Rush right out and grab "), _c('i', [_vm._v("Playing God.")]), _vm._v("” —"), _c('i', [_vm._v("Analog Science Fiction & Fact")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("THE QUIET INVASION")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Humans, aliens and Venus itself are all skillfully portrayed here, in a pleasingly complex plot. . . . A drama of considerable moral force.” —"), _c('i', [_vm._v("Locus")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“A first-contact novel worth reading and relishing.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("“Zettel demonstrates her gift for creating fully realized cultures. . . . A riveting confrontation.” —"), _c('i', [_vm._v("Booklist")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d0dfb9f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v1/2page.vue
// module id = 63
// module chunks = 0